import React from 'react';
import classNames from 'classnames';
import DynamicLeftNav from '@pages/admin/left-nav';
import { UserDetails } from '@components/header-sidebar/user-details';
import adminStyles from '@pages/admin/styles.module.scss';
import './theme-overrides.scss';

interface ApimPageShellProps {
    navSelectedId: string;
    navType: 'admin' | 'others';
    children: React.ReactNode;
}

/*
 * Shared page frame for every APIM screen — renders the same admin__container /
 * DynamicLeftNav / properties-panel layout every "Others" and "Admin" sibling page uses,
 * so APIM content sits beside the icon rail and secondary nav instead of underneath it.
 *
 * nifi_content's own padding (1.5rem 0 0 1.5rem — top/left only, zero right/bottom) is the
 * legacy convention every other admin/others page already relies on, but it reads as
 * lopsided on APIM's denser layouts (e.g. the Try It Out panel sitting flush against the
 * right edge). Padding is reset to 0 here and replaced with a symmetric 24px on all sides
 * on an inner wrapper instead, scoped to APIM only.
 */
export function ApimPageShell({ navSelectedId, navType, children }: ApimPageShellProps) {
    return (
        <section className={classNames(adminStyles['admin__container'], 'apimRoot')}>
            <DynamicLeftNav selected_id={navSelectedId} type={navType} />
            <div className={adminStyles['nifi_content']} style={{ padding: 0, overflow: 'hidden', display: 'flex' }}>
                <div style={{ padding: 24, overflowY: 'auto', width: '100%' }}>{children}</div>
            </div>
            <div className="properties__container properties__container--minimized">
                <UserDetails hideNameOnMinimize />
            </div>
        </section>
    );
}
